// src/components/institution/sections/ContactSection.jsx
import React from 'react';
import { Mail, Phone, MapPin, Clock, Globe } from 'lucide-react';

export const ContactSection = ({ data, settings, styling, onContactClick }) => {
  const contactInfo = settings?.contactInfo || data?.contactInfo || {};

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: styling?.primaryColor || '#1e40af' }}
          >
            Contact Us
          </h2>
          <div className="w-24 h-1 mx-auto mb-8" style={{ backgroundColor: styling?.primaryColor }} />
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get in touch with us for any questions or inquiries.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-6">
            <h3 className="text-2xl font-semibold text-gray-900 mb-6">
              Get in Touch
            </h3>

            <div className="space-y-4">
              {contactInfo.address && (
                <div className="flex items-start gap-4">
                  <div 
                    className="p-3 rounded-lg"
                    style={{ backgroundColor: `${styling?.primaryColor || '#1e40af'}20` }}
                  >
                    <MapPin 
                      className="h-6 w-6"
                      style={{ color: styling?.primaryColor || '#1e40af' }}
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Address</h4>
                    <p className="text-gray-600">{contactInfo.address}</p>
                  </div>
                </div>
              )}

              {contactInfo.phone && (
                <div className="flex items-start gap-4">
                  <div 
                    className="p-3 rounded-lg"
                    style={{ backgroundColor: `${styling?.primaryColor || '#1e40af'}20` }}
                  >
                    <Phone 
                      className="h-6 w-6"
                      style={{ color: styling?.primaryColor || '#1e40af' }}
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Phone</h4>
                    <a href={`tel:${contactInfo.phone}`} className="text-gray-600 hover:underline">
                      {contactInfo.phone}
                    </a>
                  </div>
                </div>
              )}

              {contactInfo.email && (
                <div className="flex items-start gap-4">
                  <div 
                    className="p-3 rounded-lg"
                    style={{ backgroundColor: `${styling?.primaryColor || '#1e40af'}20` }}
                  >
                    <Mail 
                      className="h-6 w-6"
                      style={{ color: styling?.primaryColor || '#1e40af' }}
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Email</h4>
                    <a href={`mailto:${contactInfo.email}`} className="text-gray-600 hover:underline">
                      {contactInfo.email}
                    </a>
                  </div>
                </div>
              )}

              {contactInfo.website && (
                <div className="flex items-start gap-4">
                  <div 
                    className="p-3 rounded-lg"
                    style={{ backgroundColor: `${styling?.primaryColor || '#1e40af'}20` }}
                  >
                    <Globe 
                      className="h-6 w-6"
                      style={{ color: styling?.primaryColor || '#1e40af' }}
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Website</h4>
                    <a href={contactInfo.website} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:underline">
                      {contactInfo.website}
                    </a>
                  </div>
                </div>
              )}

              {contactInfo.hours && (
                <div className="flex items-start gap-4">
                  <div 
                    className="p-3 rounded-lg"
                    style={{ backgroundColor: `${styling?.primaryColor || '#1e40af'}20` }}
                  >
                    <Clock 
                      className="h-6 w-6"
                      style={{ color: styling?.primaryColor || '#1e40af' }}
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Office Hours</h4>
                    <p className="text-gray-600">{contactInfo.hours}</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Contact Form or Map */}
          <div className="bg-white rounded-xl p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-gray-900 mb-6">
              Send us a Message
            </h3>
            
            <p className="text-gray-600 mb-6">
              Have questions or need more information? We'd love to hear from you.
            </p>

            <button
              onClick={onContactClick}
              className="w-full text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity"
              style={{ backgroundColor: styling?.primaryColor || '#1e40af' }}
            >
              Open Contact Form
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};